var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('metabase-dashboard',{attrs:{"dashboard-id":_vm.DASHBOARD_ID,"title":_vm.t('Shipment Status Report')}})}
var staticRenderFns = []

export { render, staticRenderFns }